module.exports = __webpack_public_path__ + "img/iPad Pro 12.9 - 2.ee52b991.jpg";